import * as DashboardConstants from "../../constants/DashboardConstants";
import {getByColName, resultSetSize} from "./DashBoardResultSetUtil";
import * as kendoThemeChooser from "../KednoThemeChooser";
import {calcChartTitle} from "../highCharts/HighGaugeDrawer";


/**
 *
 * @param {namaTypes.DTOUserDashbordChartLine} userDashboardChartLine
 * @param h
 * @param w
 * @return {JQuery | jQuery | HTMLElement}
 */
export function createColumnRangeChart(userDashboardChartLine, h, w, widget, chartArea) {
    let params = userDashboardChartLine.parameters;
    let xCateg = params[DashboardConstants.Param_XCategory];
    let categs = [];
    let rangeFrom = params[DashboardConstants.Param_RangeFrom];
    let rangeTo = params[DashboardConstants.Param_RangeTo];
    let yAxisTitle = params[DashboardConstants.Param_Title];
    let points = [];
    let list = userDashboardChartLine.resultSet;
    let minSet = false;
    let maxSet = false;
    let minNum = 0;
    let maxNum = 0;
    for (let i = 0; i < resultSetSize(list); i++) {
        categs[i] = getByColName(i, xCateg, list);
        let rangeFromNum = getByColName(i, rangeFrom, list);
        let rangeToNum = getByColName(i, rangeTo, list);
        points[i] = [rangeFromNum, rangeToNum];
        if (!minSet) {
            minNum = Math.min(rangeFromNum, rangeToNum);
            minSet = true;
        } else {
            minNum = Math.min(minNum, rangeFromNum, rangeToNum);
        }
        if (!maxSet) {
            maxNum = Math.max(rangeFromNum, rangeToNum);
            maxSet = true;
        } else {
            maxNum = Math.max(maxNum, minNum, rangeFromNum, rangeToNum);
        }
    }
    widget.kendoChart({
        theme: kendoThemeChooser.currentTheme(),
        title: {
            text: calcChartTitle(userDashboardChartLine)
        },
        chartArea: chartArea,

        series: [{
            type: "rangeBar",
            data: points
        }],
        seriesDefaults: {
            labels: {
                visible: true,
            }
        },
        categoryAxis: {
            categories: categs,
            labels: {
                rotation: "auto"
            }
        },
        tooltip: {
            visible: true,
            template: "#=category# <br> #=value.from# - #=value.to#"
        },
        valueAxis: {
            min: minNum - 5,
            max: maxNum + 5,
            title: {
                text: yAxisTitle
            }
        }
    });
    return widget;
}